import { EvalAnswer } from '../getCandidateEvaluations/GetCandidateEvaluationsRes'

export enum NotAFitPreference {
    SHOW_AGAIN = 'SHOW_AGAIN',
    DONT_SHOW_AGAIN = 'DONT_SHOW_AGAIN',
}

export type CandidateReviewActionReq = {
    sourcePersonId: string
    targetPersonId: string
    roleId: string
    evalAnswer: EvalAnswer
    evalComment?: string
    // only when evalAnswer = NOT_A_FIT
    notAFitPreference?: NotAFitPreference
}
